var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAuto = function SvgAuto(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2051 9.13867L9.77832 17H7.20117L10.8584 7.04688H12.4922L12.2051 9.13867ZM14.2148 17L11.7812 9.13867L11.4668 7.04688H13.1211L16.7988 17H14.2148ZM14.1191 13.2881V15.1406H9.0127V13.2881H14.1191Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAuto);
export { ForwardRef as ReactComponent };